import { AppLaunchRow } from "../components/AppLaunchRow.js";

export function Apps(): JSX.Element {
  return (
    <div className="max-w-2xl">
      <AppLaunchRow />
    </div>
  );
}
